module.exports = __webpack_public_path__ + "img/logo.c91e053d.png";